// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coming-soon-text[data-v-cbb32a2c] {
  width: 100%;
  text-align: center;
  font-size: 50px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.hammer-image[data-v-cbb32a2c] {
  width: 25%;
  margin: auto;
  justify-content: center;
  display: flex;
}
.animated[data-v-cbb32a2c] {
  animation-duration: 0.5s;
  -webkit-animation-duration: 0.5s;
  animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
@keyframes rotate-bottom-left-cbb32a2c {
0% {
    transform-origin: left bottom;
    transform: rotate(0);
}
50% {
    transform-origin: left bottom;
    transform: rotate(45deg);
}
100% {
    transform-origin: left bottom;
    transform: rotate(0);
}
}
@-webkit-keyframes rotate-bottom-left-cbb32a2c {
0% {
    transform-origin: left bottom;
    transform: rotate(0);
}
50% {
    transform-origin: left bottom;
    transform: rotate(45deg);
}
100% {
    transform-origin: left bottom;
    transform: rotate(0);
}
}
.rotate-bottom-left[data-v-cbb32a2c] {
  -webkit-animation-name: rotate-bottom-left-cbb32a2c;
  animation-name: rotate-bottom-left-cbb32a2c;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/ComingSoon.vue","webpack://./ComingSoon.vue"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;ACDF;ADIA;EACE,UAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;ACDF;ADIA;EACE,wBAAA;EACA,gCAAA;EACA,yBAAA;EACA,iCAAA;ACDF;ADIA;AACE;IACE,6BAAA;IACA,oBAAA;ACDF;ADGA;IACE,6BAAA;IACA,wBAAA;ACDF;ADGA;IACE,6BAAA;IACA,oBAAA;ACDF;AACF;ADIA;AACE;IACE,6BAAA;IACA,oBAAA;ACFF;ADIA;IACE,6BAAA;IACA,wBAAA;ACFF;ADIA;IACE,6BAAA;IACA,oBAAA;ACFF;AACF;ADKA;EACE,mDAAA;EACA,2CAAA;ACHF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.coming-soon-text {\n  width: 100%;\n  text-align: center;\n  font-size: 50px;\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n\n.hammer-image {\n  width: 25%;\n  margin: auto;\n  justify-content: center;\n  display: flex;\n}\n\n.animated {\n  animation-duration: 0.5s;\n  -webkit-animation-duration: 0.5s;\n  animation-fill-mode: both;\n  -webkit-animation-fill-mode: both;\n}\n\n@keyframes rotate-bottom-left {\n  0% {\n    transform-origin: left bottom;\n    transform: rotate(0);\n  }\n  50% {\n    transform-origin: left bottom;\n    transform: rotate(45deg);\n  }\n  100% {\n    transform-origin: left bottom;\n    transform: rotate(0);\n  }\n}\n//eslint-disable vue-scoped-css/no-unused-selector\n@-webkit-keyframes rotate-bottom-left {\n  0% {\n    transform-origin: left bottom;\n    transform: rotate(0);\n  }\n  50% {\n    transform-origin: left bottom;\n    transform: rotate(45deg);\n  }\n  100% {\n    transform-origin: left bottom;\n    transform: rotate(0);\n  }\n}\n\n.rotate-bottom-left {\n  -webkit-animation-name: rotate-bottom-left;\n  animation-name: rotate-bottom-left;\n}\n",".coming-soon-text {\n  width: 100%;\n  text-align: center;\n  font-size: 50px;\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n\n.hammer-image {\n  width: 25%;\n  margin: auto;\n  justify-content: center;\n  display: flex;\n}\n\n.animated {\n  animation-duration: 0.5s;\n  -webkit-animation-duration: 0.5s;\n  animation-fill-mode: both;\n  -webkit-animation-fill-mode: both;\n}\n\n@keyframes rotate-bottom-left {\n  0% {\n    transform-origin: left bottom;\n    transform: rotate(0);\n  }\n  50% {\n    transform-origin: left bottom;\n    transform: rotate(45deg);\n  }\n  100% {\n    transform-origin: left bottom;\n    transform: rotate(0);\n  }\n}\n@-webkit-keyframes rotate-bottom-left {\n  0% {\n    transform-origin: left bottom;\n    transform: rotate(0);\n  }\n  50% {\n    transform-origin: left bottom;\n    transform: rotate(45deg);\n  }\n  100% {\n    transform-origin: left bottom;\n    transform: rotate(0);\n  }\n}\n.rotate-bottom-left {\n  -webkit-animation-name: rotate-bottom-left;\n  animation-name: rotate-bottom-left;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
